import React, { useState } from 'react';

const ReadMore = ({ text, maxLength = 300 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded((prev) => !prev);
  };

  if (text.length <= maxLength) {
    return <p>{text}</p>;
  }

  return (
    <p>
      {isExpanded ? text : `${text.substring(0, maxLength)}...`}
      <span
        onClick={toggleReadMore}
        className='text-primary'
        style={{ color: 'blue', cursor: 'pointer', fontSize: '13px', marginLeft: '10px' }}
      >
        {isExpanded ? 'Read Less' : 'Read More'}
      </span>
    </p>
  );
};

export default ReadMore;
